<template lang="pug">
  #Sa.h-100
    router-view
</template>

<script>
  import store from '../../store';

  export default {
    // 不管這邊打大小寫 顯示都會是以大寫形式為主
    name: 'SaComponent',
    beforeRouteEnter(to, from, next) {
      store.dispatch('sa_profile/getProfileHandler')
        .then((res) => {
          if (res.data.personnel.line_position === 'sa') {
            next();
          } else {
            window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
          }
        });
    }
  };
</script>
